import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearSession, hasValidSession } from '../auth/session';

// Same gate as useAuth, for guests arriving by scanning a table QR. A guest who
// is not signed in yet has the hotel and table stashed in cookies first, so the
// sign in flow can put them back at the right table afterwards.
const useAuthForQr = (hotelId, tableId) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasValidSession()) {
      clearSession();
      document.cookie = `hotelId=${hotelId}; path=/`;
      document.cookie = `tableId=${tableId}; path=/`;
      navigate('/');
      return;
    }

    document.cookie = "hotelId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "tableId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }, [navigate, hotelId, tableId]);
};

export default useAuthForQr;
